import api from '@/api';
import * as dateutil from '@/util/date-helper.ts';
import axios from 'axios';
import { invalidateUrl } from '@appbase/util'

export default {
    /**
     * 새로운 일정을 생성합니다
     */
    createEvent(data: mail.api.DynamicApiOptions): Promise<string> {
        return api.post({
            url: '/api/ews/Calendar/create?funcName=createEvent',
            data: data
        });
    },

    /**
     * 일정을 수정합니다.
     */
    editEvent(data: mail.api.DynamicApiOptions): Promise<boolean> {
        return api.post({
            url: '/api/ews/Calendar/set?funcName=editEvent',
            data: data
        });
    },

    getBody(id: string) {
        if (!id) {
            throw new Error("ARGUMENT_NULL_EXCEPTION: {id}");
        }
        return api
            .get<string[]>({
                url: "/api/ews/body/appointmentChunk?funcName=getBody",
                params: {
                    itemId: id,
                },
            })
            .then((results) => {
                return results.map((chunk) => {
                    var decodeBase64 = atob(chunk);
                    var html = decodeURIComponent(decodeBase64);
                    return html;
                });
            })
            .then(function (htmls) {
                return htmls.join("");
            });
    },

    /**
     * 폴더의 일정들을 가져옵니다
     * @param {string} parentId root folder ID
     * @param {string} startdate 시작일
     * @param {string} enddate 종료일
     */
    getCalendarEvents(parentId: string, startdate: Date, enddate: Date): Promise<ItemList<calendar.CalendarItem>> {
        return api
            .post({
                url: '/api/ews/Dynamic/list?funcName=getCalendarEvents',
                data: {
                    fields: [
                        { key: "Id" },
                        { key: "ParentFolderId" },
                        { key: "Subject" },
                        { key: "DisplayTo" },
                        { key: "TimeZone" },
                        { key: "Sensitivity" },
                        { key: "Importance" },
                        { key: "ReminderDueBy" },
                        { key: "Location" },
                        { key: "LegacyFreeBusyStatus" },
                        { key: "Organizer", format: "obj:[name,address]" },
                        //{ key: "hasAttachments" },
                        { key: "IsRecurring" },
                        { key: "IsFromMe" },
                        { key: "IsCancelled" },
                        { key: "IsAllDayEvent" },                        
                        { key: "Start", "format": "yyyy-MM-dd HH:mm:ss" },
                        { key: "End", "format": "yyyy-MM-dd HH:mm:ss" },
                        { key: "Duration", "as": "ScheduleDuration" },
                        { key: "DateTimeCreated", "format": "yyyy-MM-dd HH:mm:ss" },
                        //{ key: "RequiredAttendees", "format": "obj:[name,address]" },
                        { key: "Categories" },
                        { key: "PidLidRecurrenceType" },
                        { key: "PidLidRecurrencePattern" },
                        // { key: "Recurrence" },
                    ],
                    filters: [
                        {
                            operator: "OR",
                            filters: [
                                {
                                    operator: "AND",
                                    filters: [
                                        {
                                            key: "Start",
                                            value: dateutil.uGetDateFormat('yyyy-MM-DD 00:00:00', startdate),
                                            valueType: "datetime",
                                            valueFormat: "yyyy-MM-dd HH:mm:ss",
                                            condition: "IsGreaterThanOrEqualTo" // Start >= start
                                        },
                                        {
                                            key: "Start",
                                            value: dateutil.uGetDateFormat('yyyy-MM-DD 00:00:00', enddate),
                                            valueType: "datetime",
                                            valueFormat: "yyyy-MM-dd HH:mm:ss",
                                            condition: "IsLessThanOrEqualTo" // <= Start <= end
                                        }
                                    ]
                                },
                                {
                                    operator: "AND",
                                    filters: [
                                        {
                                            key: "Start",
                                            value: dateutil.uGetDateFormat('yyyy-MM-DD 00:00:00', startdate),
                                            valueType: "datetime",
                                            valueFormat: "yyyy-MM-dd HH:mm:ss",
                                            condition: "IsLessThanOrEqualTo" // Start <= start
                                        },
                                        {
                                            key: "End",
                                            value: dateutil.uGetDateFormat('yyyy-MM-DD 00:00:00', startdate),
                                            valueType: "datetime",
                                            valueFormat: "yyyy-MM-dd HH:mm:ss",
                                            condition: "IsGreaterThanOrEqualTo" // End >= start
                                        }
                                    ]
                                },
                            ],
                        }
                    ],
                    parentId: parentId,
                    pageSize: 100,
                    offset: 0,
                    sorts: [
                        { "field": "Start", "dir": "desc" }
                    ],
                    type: "Calendar"
                }
            })
            .then((res: any) => {
                return res.items.map((item: calendar.CalendarItem, idx: number) => {
                    var rlt = {
                        ...item,
                        index: idx,
                        isEWS: true,
                    };
                    return rlt;
                });
            });
    },

    /**
     * 폴더의 일정들을 가져옵니다
     * @param {string} parentId root folder ID
     * @param {string} startdate 시작일
     * @param {string} enddate 종료일
     */
    getCalendarDailyEvents(parentId: string, date: Date): Promise<ItemList<calendar.CalendarItem>> {
        return api
            .post({
                url: '/api/ews/Dynamic/list?funcName=getCalendarDailyEvents',
                data: {
                    fields: [
                        { key: "Id" },
                        { key: "ParentFolderId" },
                        { key: "Subject" },
                        { key: "DisplayTo" },
                        { key: "TimeZone" },
                        { key: "Sensitivity" },
                        { key: "Importance" },
                        { key: "ReminderDueBy" },
                        { key: "Location" },
                        { key: "LegacyFreeBusyStatus" },
                        { key: "Organizer", format: "obj:[name,address]" },
                        //{ key: "hasAttachments" },
                        { key: "IsRecurring" },
                        { key: "IsFromMe" },
                        { key: "IsCancelled" },
                        { key: "IsAllDayEvent" },
                        { key: "Start", "format": "yyyy-MM-dd HH:mm:ss" },
                        { key: "End", "format": "yyyy-MM-dd HH:mm:ss" },
                        { key: "Duration", "as": "ScheduleDuration" },
                        { key: "DateTimeCreated", "format": "yyyy-MM-dd" },
                        //{ key: "RequiredAttendees", "format": "obj:[name,address]" },
                        { key: "Categories" },
                        { key: "PidLidRecurrenceType" },
                        { key: "PidLidRecurrencePattern" },
                        { key: "ReminderMinutesBeforeStart"},
                        // { key: "Recurrence" },
                        // {key: "PidLidRecurring"},
                        // {key: "PidLidRecurring"},
                    ],
                    filters: [
                        {
                            operator: "AND",
                            filters: [
                                {
                                    key: "Start",
                                    value: dateutil.uGetDateFormat('yyyy-MM-DD 23:59:59', date),
                                    valueType: "datetime",
                                    valueFormat: "yyyy-MM-dd HH:mm:ss",
                                    condition: "IsLessThanOrEqualTo"
                                },
                                {
                                    key: "End",
                                    value: dateutil.uGetDateFormat('yyyy-MM-DD 00:00:00', date),
                                    valueType: "datetime",
                                    valueFormat: "yyyy-MM-dd HH:mm:ss",
                                    condition: "IsGreaterThanOrEqualTo"
                                }
                            ]
                        },
                    ],
                    parentId: parentId,
                    pageSize: 100,
                    offset: 0,
                    sorts: [
                        { "field": "Start", "dir": "desc" }
                    ],
                    type: "Calendar"
                }
            })
            .then((res: any) => {
                return res.items.map((item: calendar.CalendarItem, idx: number) => {
                    var rlt = {
                        ...item,
                        index: idx,
                        isEWS: true,
                    };
                    return rlt;
                })
            });
    },

    getDetail(id: string): Promise<calendar.CalendarItem> {
        return api
            .post<any>({
                url: "/api/ews/dynamic/get?funcName=getDetail",
                data: {
                    fields: [
                        { key: "Id" },
                        { key: "ParentFolderId" },
                        { key: "AllowedResponseActions" },
                        { key: "Subject" },
                        { key: "DisplayTo" },
                        { key: "TimeZone" },
                        { key: "Sensitivity" },
                        { key: "Importance" },
                        { key: "ReminderDueBy" },
                        { key: "Location" },
                        { key: "LegacyFreeBusyStatus" },
                        { key: "Organizer", format: "obj:[name,address]" },
                        //{ key: "hasAttachments" },
                        { key: "MyResponseType" },
                        { key: "IsRecurring" },
                        { key: "IsFromMe" },
                        { key: "IsCancelled" },
                        { key: "IsAllDayEvent" },
                        { key: "Start", "format": "yyyy-MM-dd HH:mm:ss" },
                        { key: "End", "format": "yyyy-MM-dd HH:mm:ss" },
                        { key: "Duration", "as": "ScheduleDuration" },
                        { key: "DateTimeCreated", "format": "yyyy-MM-dd" },
                        { key: "RequiredAttendees", format: "obj:[name,address]", as: "requiredAttendees" },
                        { key: "OptionalAttendees", format: "obj:[name,address]", as: "optionalAttendees" },
                        { key: "Categories" },
                        { key: "PidLidRecurrenceType" },
                        { key: "PidLidRecurrencePattern" },
                        { key: "PidLidRecurring" },
                        { key: "Recurrence" },
                        { key: "ReminderMinutesBeforeStart"},
                        { key: "Resources", format: "obj:[name,address]" },
                        { key: "AppointmentType" },
                        {
                            key: 'Attachments',
                            format: 'obj:[id,name,contentType,size]',
                            filters: [
                                {
                                    key: 'isInline',
                                    value: false,
                                    operator: 'eq',
                                },
                            ],
                        },
                    ],
                    itemId: id,
                    type: "Calendar",
                },
            })
            .then((res) => {
                console.log('데이터',res)
                res.item.isEWS = true;
                if (res.item.resources.length) {
                    res.item.resourceId = res.item.resources[0].address;
                }
                return res.item;
            });
    },

    /**
     * 일정을 삭제합니다.
     * @param {object} id 선택한 일정 폴더 ID [ id ]
     */
    deleteEvent(id: string): Promise<boolean> {
        return api.post({
            url: '/api/ews/Calendar/delete?funcName=deleteEvent',
            data: { id: id },
        });
    },

    /**
     * 일정을 수락합니다.
     * @param {object} id 선택한 일정 폴더 ID [ id ]
     */
    acceptEvent(id: string) {
        return api.post<any>({
            url: '/api/ews/Calendar/accept?funcName=acceptEvent',
            data: { id: id },
        });
    },

    /**
     * 일정을 거절합니다.
     * @param {object} id 선택한 일정 폴더 ID [ id ]
     */
    declineEvent(id: string) {
        return api.post<any>({
            url: '/api/ews/Calendar/decline?funcName=declineEvent',
            data: { id: id },
        });
    },

    /**
     * 일정을 취소합니다.
     * @param {object} id 선택한 일정 폴더 ID [ id ]
     */
    cancelEvent(item: calendar.CalendarItem) {
        return api.post<any>({
            url: '/api/ews/Calendar/cancel?funcName=cancelEvent',
            data: { 
                id: item.id,
                body: item.body,
            },
        });
    },

    /**
     * 반복일정 마스터 아이디를 가져옵니다
     * @param id 
     */
    getRecurringMasterID(id: string) {
        return api.post<string>({
            url: '/api/ews/Calendar/getmasterid?funcName=getRecurringMasterID',
            data: {
                id: id,
            }
        });
    },

    /**
     * 폴더의 일정들을 가져옵니다
     * @param {string} parentId root folder ID
     * @param {string} startdate 시작일
     * @param {string} enddate 종료일
     */
    searchCalendarEventList(item: calendar.SearchOptions) {
        return api.post<Array<any>>({
            url: '/api/ews/Calendar/search?funcName=searchCalendarEventList',
            data: {
                EwsFolderIDArray: item.EwsFolderIDArray || null,
                EwsFolderID: item.ParentFolderID || null, 
                StartDate: item.StartDate || null, 
                EndDate: item.EndDate || null,
                Keyword: item.Keyword || null, 
                Subject: item.Subject || null,
                Location: item.Location || null, 
                OrganizerAddress: item.OrganizerAddress || null, 
                PersonCode: item.PersonCode, 
                RequiredAttendees: null, 
                OptionalAttendees: null, 
                EumNoCondition: false, 
                EumPageNumber: item.EumPageNumber || 1, 
                EumRowsPerPage: item.EumRowsPerPage || 9999, 
            }
        }).then((res) => {
            return res.map((data) => {
                let result = {
                    ...data,
                    isEWS: true,
                };
                return result;
            });
        });;
    },

    /**
     * 폴더의 일정들을 가져옵니다 (반복일정 포함)
     * @param {string} parentId root folder ID
     * @param {string} startdate 시작일
     * @param {string} enddate 종료일
     */
    getCalendarEventListWithRecurrence(item: calendar.SearchOptions) {
        return api.post<Array<any>>({
            url: '/api/ews/Calendar/list?funcName=getCalendarEventListWithRecurrence',
            data: {
                EwsFolderIDArray: item.EwsFolderIDArray || null,
                EwsFolderID: item.ParentFolderID || null, 
                StartDate: item.StartDate || null, 
                EndDate: item.EndDate || null, 
                Subject: item.Subject || null,
                Location: item.Location || null, 
                OrganizerAddress: item.OrganizerAddress || null, 
                PersonCode: item.PersonCode, 
                RequiredAttendees: null, 
                OptionalAttendees: null, 
                EumNoCondition: false, 
                EumPageNumber: item.EumPageNumber || 1, 
                EumRowsPerPage: item.EumRowsPerPage || 9999, 
            }
        }).then((res) => {
            return res.map((data) => {
                let result = {
                    ...data,
                    isEWS: true,
                };
                return result;
            });
        });;
    },

    /**
     * 연락처 목록을 파일로 다운로드 합니다
     * @param data 
     * @param {enum} type DB,exchange 버전 구분
     */
    downloadCalendarList(item: calendar.SearchOptions){
        return axios({
            method: 'post',
            url: invalidateUrl('/api/ews/calendar/download?funcName=downloadCalendarList'),
            responseType: 'arraybuffer',
            data: {
                EwsFolderIDArray: item.EwsFolderIDArray || null,
                EwsFolderID: item.ParentFolderID || null, 
                FolderIDArray: item.FolderIDArray || null,
                StartDate: item.StartDate || null, 
                EndDate: item.EndDate || null,
                Keyword: item.Keyword || null, 
                Subject: item.Subject || null,
                Location: item.Location || null, 
                OrganizerAddress: item.OrganizerAddress || null, 
                PersonCode: item.PersonCode, 
                RequiredAttendees: null, 
                OptionalAttendees: null, 
                EumNoCondition: false, 
                EumPageNumber: item.EumPageNumber || 1, 
                EumRowsPerPage: item.EumRowsPerPage || 9999, 
            }
        }).then(function(response){
            console.log('response', response);
            const disposition = response.headers['content-disposition'];
            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = filenameRegex.exec(disposition);
            var fileName = '';
            if (matches != null && matches[1]) {
                fileName = matches[1].replace(/['"]/g, '');
                if (fileName) {
                    fileName = decodeURIComponent(fileName);
                }
            }
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
            //IE 경우
            if(window.navigator && window.navigator.msSaveOrOpenBlob){
                window.navigator.msSaveOrOpenBlob(blob, fileName);
            }else{
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `${fileName}`;
                link.click();
                (process as any).nextTick(() => link.remove());
            }
        });
    },
}